import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path:'/Login',
      name: 'Login',
      component: () => import( './views/Logon.vue'),
    },
	{                     //常见问题
	  path:'/commonProblem',
	  name: 'commonProblem',
	  component: () => import( './views/CommonProblem.vue')
	},
	{                     //地址
	  path:'/homeAddress',
	  name: 'homeAddress',
	  component: () => import( './views/homeAddress.vue'),
	  meta:{requireAuth:true}
	},
	{                     //我的
	  path:'/mineH5',
	  name: 'mineH5',
	  component: () => import( './views/mineH5.vue'),
	  meta:{requireAuth:true}
	},
	{                     //产品列表
	  path:'/',
	  name: 'productH5',
	  component: () => import( './views/ProductH5.vue'),
	  meta:{requireAuth:true}
	},
	{                     //产品详情
	  path:'/productDetail',
	  name: 'productH5Detail',
	  component: () => import( './views/ProductH5Detail.vue'),
	  meta:{requireAuth:true}
	},
    {
      path:'/beforeQuestion',
      name: 'beforeQuestion',
      component: () => import( './views/beforeQuestion.vue'),
      meta:{requireAuth:true}
    },
    {
      path:'/questions',
      name: 'Questions',
      component: () => import( './views/Questions.vue'),
      meta:{requireAuth:true}
    },
    {
      path:'/questionnaire',
      name: 'Questionnaire',
      component: () => import( './views/Questionnaire.vue'),
      meta:{requireAuth:true}
    },
    {             //首页
      path: '/index',
      name: 'index',
      component: Index,
    },
    {             //橘袋详情
      path: '/cartDetail',
      name: 'cartDetail',
      component: () => import('./views/cartDetail.vue'),
      meta:{requireAuth:true}
    },
    {             //橘袋
      path: '/cart',
      name: 'cart',
      component: () => import('./views/Cart.vue'),
      meta:{requireAuth:true}	
    },
    {             //创建订单
      path: '/makeOrder',
      name: 'orderMade',
      component: () => import('./views/orderMade.vue'),
      meta:{requireAuth:true}
    },
    {             //报告列表
      path: '/report',
      name: 'report',
      component: () => import('./views/Report.vue'),
	  meta:{requireAuth:true}
    },
	
    {             //报告详情
      path: '/reportDetail',
      name: 'reportDetail',
      component: () => import( './views/ReportDetail.vue'),
	  meta:{requireAuth:true}
    },
    {             //订单列表
      path: '/orderList',
      name: 'orderList',
      component: () => import('./views/orderList.vue'),
	  meta:{requireAuth:true}
    },
    {             //订单详情
      path:'/orderDetail',
      name: 'orderDetail',
      component: () => import('./views/orderDetail.vue'),
	  meta:{requireAuth:true}
    },
    {             //我的
      path: '/mine',
      name: 'mine',
      component: () => import('./views/About.vue')
    },
    
    {
      path:'/contact',
      name: 'Contact',
      component: () => import( './views/Contact.vue')
    },
     {
      path:'/product',
      name: 'Product',
      component: () => import( './views/Product.vue')
    },
    {
      path:'/goods',
      name: 'Goods',
      component: () => import( './views/Goods.vue')
    },
    {
      path:'/about',
      name: 'About',
      component: () => import( './views/About.vue')
    },
    {
      path:'/doctor',
      name: 'Doctor',
      component: () => import( './views/Doctor.vue')
    },
    {
      path:'/communication',
      name: 'Communication',
      component: () => import( './views/Communication.vue')
    },
    {
      path:'/clause',
      name: 'clause',
      component: () => import( './views/clause.vue')
    },
    {
      path:'/privacy',
      name: 'Privacy',
      component: () => import( './views/Privacy.vue')
   },
   {path:'*',redirect:'/'},
]

})





